import {LAYOUT} from '@dofleini/auth-layout';
import LoginImageSide from '../assets/images/authBg.svg';

export const authentication = {
  image: LoginImageSide,
  background: '#1C7BF7',
  formBackground: '#ffffff',
  layout: LAYOUT.CENTER_BOX,
  path: '/ms-auth',
  showInviteLInk: false,
  showUserName: true,
  showAddress: false,
  //in milliseconds
  tokenExpirationTime: 2 * 60 * 60 * 1000,
  activeOnboarding: false,
  hideOnBoardingFb: true,
  hideOnBoardingGoogle: true,
  isSaas: true,
  baseDomain: 'ecommerce-staging.dofleinisoftware.com'
};
